import api from './api';

export const aiService = {
  // Generate a complete quiz with AI
  generateQuiz: async (data) => {
    try {
      const response = await api.post('/ai/generate-quiz', data);
      return response.data;
    } catch (error) {
      console.error('Error generating quiz:', error);
      throw error;
    }
  },

  // Test AI connection
  testConnection: async () => {
    try {
      const response = await api.get('/ai/test-connection');
      return response.data;
    } catch (error) {
      console.error('Error testing AI connection:', error);
      throw error;
    }
  }
};